export default __webpack_public_path__ + "static/media/card_container_skeleton.d4f3d884.png";